import React from "react";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import {
  Document,
  Font,
  Page,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import iransans from "../../../assets/fonts/vazir/Farsi-Digits-Without-Latin/Vazir-FD-WOL.ttf";
import calculateValueCheque from "../../../utility/CalculateValueCheque/calculateValueCheque";
import moment from "moment";
import momentjalal from "moment-jalaali";

const ChequeContractPrint = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { data } = props;

  return (
    <>
      <Button
        color={"primary"}
        variant={"outlined"}
        onClick={(e) => setOpenModal(true)}
      >
        چاپ
      </Button>
      <Dialog
        open={openModal}
        onClose={(e) => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <PDFDownloadLink
            document={
              <CarCOntractPdfGenerator
                data={data}
                firstCheques={props.firstCheques}
                secondCheques={props.secondCheques}
                percent={props.percent}
                originDate={props.originDate}
                setOriginDate={props.setOriginDate}
                title={"فرم معامله ماشین"}
              />
            }
            fileName="download_pdf.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "در حال آماده سازی فایل ..." : "دانلود نمایید!"
            }
          </PDFDownloadLink>
        </DialogContent>
      </Dialog>
    </>
  );
};

const Table = ({ children }) => (
  <View
    style={{
      marginTop: 8,
      marginBottom: 8,
      borderTop: "1 solid black",
      borderLeft: "1 solid black",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </View>
);

const TableRow = ({ style, children }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      ...style,
    }}
  >
    {children}
  </View>
);

const TableCell = ({ style, children }) => (
  <View
    style={{
      flex: 1,
      borderRight: "1 solid black",
      borderBottom: "1 solid black",
      paddingRight: 3,
      paddingTop: 3,
      paddingBottom: 3,
      textAlign: "right",
      direction: "rtl",
      ...style,
    }}
  >
    <Text>{children}</Text>
  </View>
);

function formatCurrency(n, currency) {
  return (
    currency +
    n.toFixed(0).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    })
  );
}

const CarCOntractPdfGenerator = (props) => {
  Font.register({
    family: "IRANSans",
    src: iransans,
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontFamily: "IRANSans",
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      textAlign: "right",
    },
    cellHeader: {
      fontSize: 8,
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
    },
  });

  const rowCheque = (cheq) => {
    return (
      <TableRow>
        {/*<TableCell>{cheq.reciver_user_fullname}</TableCell>*/}
        <TableCell>{cheq.giver_user_fullname}</TableCell>

        <TableCell>{cheq.cheque_id}</TableCell>
        <TableCell>
          {formatCurrency(
            calculateValueCheque(
              props.percent,
              cheq.amount,
              parseInt(
                moment(cheq.due_date).diff(moment(props.originDate), "days"),
              ),
            ),
            "",
          )}
        </TableCell>

        <TableCell>{formatCurrency(cheq.amount, "")}</TableCell>

        <TableCell>{cheq.due_date_fa}</TableCell>
      </TableRow>
    );
  };

  return (
    <Document
      file="somefile.pdf"
      onLoadSuccess={(e) => {}}
    >
      <Page size="A4" style={styles.body}>
        {/*<Text style={{textAlign: "right", fontSize: 18}}>{props.title}</Text>*/}
        <View
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <View style={{ flex: 1 }}>
            <Table>
              <TableRow>
                <TableCell>
                  {props.data.id}
                  شماره سند :
                </TableCell>
                <TableCell>
                  {props.data.agreement_date_fa}
                  تاریخ سند :
                </TableCell>
              </TableRow>
            </Table>
          </View>
          <View
            style={{
              paddingTop: 5,
              width: 100,
              textAlign: "right",
              fontSize: 13,
              border: "1س solid black",
            }}
          >
            <Text>بنگاه فریدونی</Text>
          </View>
        </View>
        <View>
          <Table>
            <TableRow style={{ fontSize: 14 }}>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                اطلاعات طرفین
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {props.data.first_party_fullname}
                نام طرف دوم :
              </TableCell>
              <TableCell>
                {props.data.second_party_fullname}
                نام طرف اول :
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {momentjalal(props.originDate)
                  .format("jYYYY")
                  .split("")
                  .reverse()
                  .join("")}
                /
                {momentjalal(props.originDate)
                  .format("jMM")
                  .split("")
                  .reverse()
                  .join("")}
                /
                {momentjalal(props.originDate)
                  .format("jDD")
                  .split("")
                  .reverse()
                  .join("")}
                تاریخ مبدا :
              </TableCell>
              <TableCell>
                {props.data.ratio}
                درصد توافق :
              </TableCell>
              <TableCell>
                {props.firstCheques.reduce(
                  (prevValue, currentValue) => prevValue + currentValue.amount,
                  0,
                )}
                ارزش واقعی :
              </TableCell>
              <TableCell>
                {parseInt(
                  props.firstCheques.reduce(
                    (prevValue, currentValue) =>
                      prevValue +
                      calculateValueCheque(
                        props.percent,
                        currentValue.amount,
                        parseInt(
                          moment(currentValue.due_date).diff(
                            moment(props.originDate),
                            "days",
                          ),
                        ),
                      ),
                    0,
                  ),
                )}
                ارزش نهایی :
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                توضیحات :{"\n"}
                {props.data.description}
              </TableCell>
            </TableRow>

            <TableRow style={{ fontSize: 14 }}>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                چک های خروجی
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>دهنده</TableCell>
              <TableCell>شماره چک</TableCell>

              <TableCell>ارزش</TableCell>

              <TableCell>مبلغ</TableCell>

              <TableCell>سر رسید</TableCell>
            </TableRow>

            {props.firstCheques ? (
              props.firstCheques.map((cheq) => {
                return rowCheque(cheq);
              })
            ) : (
              <Text></Text>
            )}
          </Table>
        </View>
      </Page>
    </Document>
  );
};
export default ChequeContractPrint;
